import Pickaxe from 'assets/icons/pickaxe.svg';
import Flask from 'assets/icons/flask.svg';
import TruckBolt from 'assets/icons/truck-bolt.svg';
import Architer from 'assets/icons/architer.svg';
import PC from 'assets/icons/pc.svg';

const gap = { gap: { tablet: '10px', laptop: '20px' } };

export const oilAndGasTechExpertData = {
  title: (
    <>
      Программные решения
      <br />и услуги для нефтегаза
    </>
  ),
  titleProps: {
    fontSize: { mobile: '28px', tablet: '36px', laptop: '48px' },
    maxW: { mobile: '350px', tablet: '560px', laptop: '1000px' },
  },
  tabTitleProps: { fontSize: { mobile: '18px', laptop: '20px' } },

  cardsData: [
    {
      title: 'Геологоразведка и добыча',
      titleProps: { fontSize: '24px' },
      tabIcon: Pickaxe,
      content:
        'Разрабатываем автоматизированные рабочие места с применением передовых технологий и алгоритмов анализа данных. Внедряем цифровые решения и системы мониторинга для повышения эффективности и снижения затрат на добычу углеводородов',
      gap,
    },
    {
      title: 'Переработка и сбыт',
      titleProps: { fontSize: '24px' },
      tabIcon: Flask,
      content:
        'Разрабатываем и адаптируем системы управления производственными процессами (MES) и системы управления активами предприятия (EAM) под потребности клиента для управления процессами переработки углеводородов. Внедряем системы управления взаимоотношениями с клиентами (CRM) для повышения эффективности производства',
      gap,
    },
    {
      title: 'Транспорт и логистика',
      titleProps: { fontSize: '24px' },
      tabIcon: TruckBolt,
      content:
        'Интегрируем программные платформы для управления логистикой и оптимизации цепочек поставок с применением аналитики и искусственного интеллекта (AI). Реализуем проекты контроля отгрузки и налива нефтепродуктов на базе решений 1С',
      gap,
    },
    {
      title: 'Нефтесервисные компании',
      titleProps: { fontSize: '24px' },
      tabIcon: Architer,
      content:
        'Автоматизируем процессы нефтегазовых операций, внедряем аналитические системы, разрабатываем агентов на основе искусственного интеллекта для задач бурения, оптимизируем технологические режимы эксплуатации оборудования',
      gap,
    },
    {
      title: 'Внутренние операционные подразделения',
      titleProps: { fontSize: '24px' },
      tabIcon: PC,
      content:
        'Автоматизируем процессы внутренних подразделений через современные системы информационных технологий для оптимизации учёта и управления ресурсами',
      gap,
    },
  ],
};
